<template>
  <v-sheet tile elevation="1" height="100%" class="mt-2 pa-8">
    <v-container fluid>
      <v-row class="ma-0 pb-8 pt-4">
        <span class="main-title">Programação de abate</span>
        <v-spacer />
        <slaughter-schedule-create-dialog>
          <template v-slot:activator="{ on }">
            <v-btn depressed color="#2BC1B6" class="white--text" v-on="on">Criar nova programação</v-btn>
          </template>
        </slaughter-schedule-create-dialog>
      </v-row>
      <v-row>
        <v-col
          v-for="item in slaughterSchedulesSorted"
          :key="item.idProgramacaoAbate"
          class="five-cols"
        >
          <SlaughterScheduleCard :item="item" @deleted="onDeleted" @updated="onUpdated"/>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapActions } from "vuex";
import SlaughterScheduleCard from "@/modules/programacaoAbate/components/WeekTab/SlaughterScheduleCard";
import SlaughterScheduleCreateDialog from "@/modules/programacaoAbate/components/WeekTab/SlaughterScheduleCreateDialog";
import Vue from "vue";

export default {
  name: "SlaughterScheduleWeek",
  components: { SlaughterScheduleCreateDialog, SlaughterScheduleCard },
  data: () => ({
    slaughterSchedules: [],
  }),
  methods: {
    ...mapActions("programacaoAbate", ["actionClearAllInfos"]),
    onUpdated(item) {
      const idx = this.slaughterSchedules.findIndex(p => p.idProgramacaoAbate === item.idProgramacaoAbate)
      if (idx > -1) {
        this.slaughterSchedules.splice(idx, 1, item)
      }
    },
    listSlaughterSchedules() {
      this.$axios("programacao-abate/lista-programacoes/").then(
        (res) => {
          if (!res.data) return;
          if (!res.data.length > 0) return;
          if (!res.data[0].data) return;

          this.slaughterSchedules = res.data[0].data;
          this.loadHistoryStats();
        }
      );
      this.actionClearAllInfos();
    },
    loadHistoryStats() {
      if (!this.slaughterSchedules) return;

      this.slaughterSchedules.forEach((programacao) => {
        this.$axios(
          "programacao-abate/atualiza-status/?cd_programacao_abate=" +
            programacao.idProgramacaoAbate
        ).then((res) => {
          if (!res.data) return;
          if (!res.data.length > 0) return;
          if (!res.data[0].data) return;

          let listSorted = res.data[0].data.sort(
            (a, b) => a.idProgramacaoAbateStatus - b.idProgramacaoAbateStatus
          );

          let ultimoBatchConfimed = 0;
          let listFiltered = listSorted.filter(
            (x) => x.cdStatusProgramacaoAbate == 3
          );
          if (listFiltered) {
            listFiltered.forEach((item) => {
              if (item.idProgramacaoAbateStatus > ultimoBatchConfimed) {
                ultimoBatchConfimed = item.idProgramacaoAbateStatus;
              }
            });
          }

          let hasConfirm = false;
          listSorted.forEach((item) => {
            if (item.cdStatusProgramacaoAbate == 3) {
              if (
                hasConfirm &&
                ultimoBatchConfimed != item.idProgramacaoAbateStatus
              ) {
                Vue.set(item, "cdStatusProgramacaoAbate", 7);
                item.cdStatusProgramacaoAbate = 7;
              } else {
                hasConfirm = true;
              }
            }
          });

          Vue.set(programacao, "lista_status_historico", listSorted);
          programacao.lista_status_historico = listSorted;
        });
      });
    },
    onDeleted() {
      this.listSlaughterSchedules();
    }
  },
  mounted() {
    this.listSlaughterSchedules();
  },
  computed: {
    slaughterSchedulesSorted() {
      return this.slaughterSchedules.sort(
        (a, b) => b.idProgramacaoAbate - a.idProgramacaoAbate
      );
    },
  },
};
</script>

<style scoped lang="scss">
.main-title {
  font: normal normal bold 24px/32px Roboto;
  letter-spacing: 0;
  color: #37565c;
  opacity: 1;
}

.five-cols {
  flex: 0 1 20% !important;
}
</style>